module.exports = __webpack_public_path__ + "img/Libya.9779ce50.gif";